import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ProgramtypeListComponent } from './programtype-list/programtype-list.component';
import { ProgramtypeCreateComponent } from './programtype-create/programtype-create.component';


const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'list',
        component: ProgramtypeListComponent,
        data: {
          title: "Programtype List",
          breadcrumb: "Programtype List"
        }
      },
      {
        path: 'create',
        component: ProgramtypeCreateComponent,
        data: {
          title: "Create Programtype",
          breadcrumb: "Create Programtype"
        }
      },
      {
        path: 'edit/:id',
        component: ProgramtypeCreateComponent,
        data: {
          title: "Edit Programtype",
          breadcrumb: "Edit Programtype"
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})

export class ProgramtypeRoutingModule { }
